import { sleep } from 'common/utilities/timeout/timeout';

export interface ImagePart {
  /** img blob */
  data: Blob;
  x: number;
  y: number;
  /** img from url */
  img?: {
    src: string;
    width: number;
    height: number;
  };
}

export async function combineImages(
  width: number,
  height: number,
  // data as string buffer
  images: ImagePart[],
) {
  const canvasEl = document.createElement('canvas');
  canvasEl.setAttribute('width', `${width}px`);
  canvasEl.setAttribute('height', `${height}px`);

  const canvasElCtx = canvasEl.getContext('2d');
  if (!canvasElCtx) return undefined;

  canvasElCtx.fillStyle = 'white';
  canvasElCtx.fillRect(0, 0, width, height);

  images.forEach((image) => {
    let url: string | undefined;

    const img = new Image();
    if (image.img) {
      img.src = image.img.src;
      img.width = image.img.width;
      img.height = image.img.height;
      img.crossOrigin = 'anonymous';
    } else {
      const blob = new Blob([image.data], { type: 'image/png' });
      url = URL.createObjectURL(blob);
    }

    img.onload = () => {
      canvasElCtx.drawImage(img, image.x, image.y, img.width, img.height);
      if (url) URL.revokeObjectURL(url);
    };

    if (url) img.src = url;
  });

  await sleep(1000); // give time to the time for the two images to load from the Blob

  return canvasEl.toDataURL('image/png', 1.0);
}
